/* eslint func-names: 0 */
import {APPLY_TO_COLLECTIONS, APPLY_TO_PRODUCTS, APPLY_TO_STORE} from "../../../../assets/js/_contants";

/**
 * @param {Env} env
 * @param {Settings} settings
 * @param {Snippet} snippet
 * @param {Customization} customization
 * @constructor
 */
export const AppConfig = function (env, settings, snippet, customization) {

  /**
   *
   */
  this.init = () => {
    settings.init();
    this.customization().onConfigReady(this);
  };

  /**
   * @return {Env}
   */
  this.env = () => env;

  /**
   * @return {Settings}
   */
  this.settings = () => settings;

  /**
   * @return {Snippet}
   */
  this.snippet = () => snippet;

  /**
   * @return {Customization}
   */
  this.customization = () => customization;

  /**
   *
   * @param {string} page
   * @returns {boolean|boolean}
   */
  this.isAppActive = (page) => {
    if (page !== 'products') {
      return false;
    }

    const snippet = this.snippet();
    const settings = this.settings();
    const applyTo = settings.settings.apply_to;

    const collectionsIntersection = settings.target_collections.filter(id => snippet.productCollections.includes(id));
    return applyTo === APPLY_TO_STORE
      || (applyTo === APPLY_TO_PRODUCTS && settings.target_products.includes(snippet.productId))
      || (applyTo === APPLY_TO_COLLECTIONS && collectionsIntersection.length > 0) ;
  }
};
